import {
  ExternalItemCreate,
  ExternalItemEdit,
  ExternalItemList,
  ExternalItemShow
} from 'pages/external_items';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'external_items',
  label: 'Itens externos',
  list: ExternalItemList,
  show: ExternalItemShow,
  edit: ExternalItemEdit,
  create: ExternalItemCreate,
  actions: ['list', 'show', 'edit', 'create'],
  parentName: 'course_creation'
};

export default generateResources(resource);
